/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DIALOG_SIZE_SM, DialogContentProps, DialogProps } from '@squiz/sds';
import React from 'react';
import { ExtractArchiveDialogContent } from '../elements/ExtractArchiveDialogContent/ExtractArchiveDialogContent';
import { ExtractArchiveDialogContentProps } from '../elements/ExtractArchiveDialogContent/ExtractArchiveDialogContent.props';

export const getExtractDialogProps = ({
  fileId,
}: ExtractArchiveDialogContentProps): Omit<DialogProps, 'stateHandler'> => {
  // tested, but not getting the coverage
  // istanbul ignore next
  return {
    classes: 'file-explorer__dialog extract-archive remove-heading',
    dialogContent: {
      renderContent: (props: DialogContentProps): JSX.Element => {
        const contentProps = { ...props };
        contentProps.customProps = { fileId } as ExtractArchiveDialogContentProps;

        return <ExtractArchiveDialogContent {...contentProps} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM,
    heading: '',
  };
};
